import React, { Component } from "react";
import { validate } from "../../util/validate";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Spinner from "../UI/Spinner/Spinner";
import ViomeIcon from "../../ViomeIcon.jpg";
import "./Auth.css";
import * as actions from "../../redux/actions/index";

class Auth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formIsValid: false,
      formControls: {
        email: {
          value: "",
          valid: false,
          touched: false,
          validationRules: {
            isEmail: true,
            isRequired: true
          }
        },
        password: {
          value: "",
          valid: false,
          touched: false,
          validationRules: {
            isRequired: true
          }
        }
      }
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.formSubmitHandler = this.formSubmitHandler.bind(this);
  }

  changeHandler(event) {
    const name = event.target.name;
    const value = event.target.value;

    const updatedControls = {
      ...this.state.formControls
    };
    const updatedFormElement = {
      ...updatedControls[name]
    };
    updatedFormElement.value = value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = validate(
      value,
      updatedFormElement.validationRules
    );

    updatedControls[name] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedControls) {
      formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      formControls: updatedControls,
      formIsValid: formIsValid
    });
  }

  componentDidMount() {
    if (!this.props.authRedirectPath !== "/") {
      this.props.onSetAuthRedirectPath();
    }
  }

  formSubmitHandler(event) {
    const { email, password } = this.state.formControls;
    this.props.onAuth(email.value, password.value, true);
    event.preventDefault();
  }

  render() {
    const { loading, error,isAuthenticated } = this.props;
    let spinner = null;
    if (loading) {
      spinner = <Spinner />;
    }
    let errorMessage = null
    let authRedirect = null;
    if (isAuthenticated) {
      authRedirect = <Redirect to="/generate"/>;
    }
    if(error){
      authRedirect = <Redirect to="/login"/>
      errorMessage = (
        <span>
          <h4 className="Error">{error}</h4>
        </span>
      );
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <form>
              <div className="imgcontainer">
                <img src={ViomeIcon} alt="Avatar" className="avatar" />
              </div>
              <div className="container ">
                <input
                  type="text"
                  className="email"
                  placeholder="Enter Username"
                  name="email"
                  value={this.state.formControls.email.value}
                  onChange={this.changeHandler}
                />
                <input
                  type="password"
                  className="password"
                  placeholder="Enter Password"
                  name="password"
                  value={this.state.formControls.password.value}
                  onChange={this.changeHandler}
                />
                <button
                  type="submit"
                  onClick={this.formSubmitHandler}
                  disabled={!this.state.formIsValid}
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
        {spinner}
        {errorMessage}
        {authRedirect}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAuth: (email, password, rememberMe) =>
      dispatch(actions.auth(email, password, rememberMe)),
    onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath("/"))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
